const data = {
  pageName: "eBillManagement",
  services: {
    translations: {
      url: "eBillManagement/translations",
      params: {}
    },
    userServices: {
      url: "eBillManagement/userServices",
      params: {}
    },
    settings: {
      url: "eBillManagement/settings",
      params: {}
    },
    saveSettings: {
      url: "eBillManagement/saveSettings",
      params: {}
    }
  },
  termsLink: "/",
  csrfToken: "ce0e81e9af0cc3ad48721b98943bc3f09c156b10590e6ad5c2d5b7b03e33f515"
};
exports.data = data;
